export const getIsBuilderEditor = (): boolean =>
  ['EDITOR3', 'STUDIO2'].includes((globalThis as any).commonConfig?.host);
